import HelpPage from './HelpPage';
import { HelpPageProps, HelpPageValueProps } from './types';

export type { HelpPageProps, HelpPageValueProps };
export default HelpPage;
